import React from 'react';
import { ExternalLink } from 'lucide-react';
import BaseWalkthrough from './walkthroughs/BaseWalkthrough';
import chromeExtensionImage from '../assets/chrome-extension.png';
import aidenImage from '../assets/aiden.png';
import sessionTokenImage from '../assets/session-token.png';
import authenticatedImage from '../assets/authenticated.png';
import addToCrmImage from '../assets/add-to-crm.png';
import './ChromeExtensionWalkthrough.css';

interface ChromeExtensionWalkthroughProps {
  onClose: () => void;
}

const ChromeExtensionWalkthrough: React.FC<ChromeExtensionWalkthroughProps> = ({ onClose }) => {
  const handleOpenChromeStore = () => {
    window.open('https://chromewebstore.google.com/detail/mantisflow-crm/lfmjkkibcoifoaoilcmoepckhjkhbcna', '_blank');
  };

  const handleOpenLinkedIn = () => {
    window.open('https://www.linkedin.com/in/aidangomez/', '_blank');
  };

  return (
    <BaseWalkthrough
      title="Chrome Extension Setup"
      subtitle="Follow these steps to add LinkedIn profiles to your CRM with the click of a button!"
      onClose={onClose}
      className="chrome-walkthrough"
      footer={<p>That's it! Now you can quickly add any LinkedIn profile to your CRM.</p>}
    >
      <div className="chrome-walkthrough-steps">
        {/* Step 1 */}
        <div className="walkthrough-step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>Install the Chrome Extension</h3>
            <p>Go to the Chrome Web Store and add the MantisFlow CRM extension to your browser.</p>
            <div className="step-image">
              <img src={chromeExtensionImage} alt="MantisFlow Chrome Extension" />
            </div>
            <button className="step-cta-button" onClick={handleOpenChromeStore}>
              <ExternalLink size={16} />
              Open Chrome Web Store
            </button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="walkthrough-step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>Go to LinkedIn</h3>
            <p>Navigate to LinkedIn and find a profile that interests you. For example, lets look at Aidan! Notice you cant add because the token isnt set.</p>
            <button className="step-link-button" onClick={handleOpenLinkedIn}>
              linkedin.com/in/aidangomez <ExternalLink size={14} />
            </button>
            <div className="step-image">
              <img src={aidenImage} alt="LinkedIn profile example" />
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="walkthrough-step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>Get Your Session Token</h3>
            <p>Go to your profile page and find your Session Token under the API ACCESS section.</p>
            <div className="step-image">
              <img src={sessionTokenImage} alt="Session token location" />
            </div>
          </div>
        </div>

        {/* Step 4 */}
        <div className="walkthrough-step">
          <div className="step-number">4</div>
          <div className="step-content">
            <h3>Authenticate the Extension</h3>
            <p>Enter your session token into the Chrome extension to authenticate.</p>
            <div className="step-image">
              <img src={authenticatedImage} alt="Authenticated extension" />
            </div>
          </div>
        </div>

        {/* Step 5 */}
        <div className="walkthrough-step">
          <div className="step-number">5</div>
          <div className="step-content">
            <h3>Add to CRM</h3>
            <p>Click "Add to CRM" to save the LinkedIn profile to your MantisFlow CRM!</p>
            <div className="step-image">
              <img src={addToCrmImage} alt="Add to CRM button" />
            </div>
          </div>
        </div>
      </div>
    </BaseWalkthrough>
  );
};

export default ChromeExtensionWalkthrough;
